import { render, staticRenderFns } from "./week-overview.vue?vue&type=template&id=0bd6b905&"
import script from "./week-overview.ts?vue&type=script&lang=ts&"
export * from "./week-overview.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports